// Steps/AudienceSelection.js - Step 1 Component
import React, { useContext, useEffect } from 'react';
import { Box, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Card, CardContent, Avatar, Button } from '@mui/material';
import { People, Engineering, UploadFile } from '@mui/icons-material';
import { NotificationDataContext } from '../AddEditNotification';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import NavigationButton from './NavigationButton';

const AudienceSelection = () => {
    const { notificationData, setNotificationData ,initialState,steps,activeStep,setActiveStep,completedSteps, setCompletedSteps} = useContext(NotificationDataContext);
    
    const {control,watch,handleSubmit,formState:{isDirty},setValue} = useForm({
        mode: 'onChange',
        defaultValues: {
            audienceType: ''
        }
    });
    const completeStep = (data) => {
        console.log('Audience Selection Data:', data);
        // Clear opposite type's selections when audienceType changes
        const updatedData = {
            ...notificationData,
            audienceType: data.audienceType
        };
        
        // If switching to customer, clear expert and CSV selections
        if (data.audienceType === 'customer' && notificationData.audienceType !== 'customer') {
            updatedData.expertFilters = initialState.expertFilters;
            updatedData.csvUploadData = initialState.csvUploadData;
        }
        // If switching to expert, clear customer and CSV selections
        if (data.audienceType === 'expert' && notificationData.audienceType !== 'expert') {
            updatedData.customerFilters = initialState.customerFilters;
            updatedData.csvUploadData = initialState.csvUploadData;
        }
        // If switching to CSV upload, clear customer and expert selections
        if (data.audienceType === 'csvUpload' && notificationData.audienceType !== 'csvUpload') {
            updatedData.customerFilters = initialState.customerFilters;
            updatedData.expertFilters = initialState.expertFilters;
        }
        
        setNotificationData(updatedData);
        
        if (activeStep < steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setCompletedSteps((prev) => {
                prev.add(activeStep);
                return new Set(prev);
            });
        }
    }
    useEffect(() => {
        if(notificationData.audienceType){
            setValue('audienceType',notificationData.audienceType,{shouldValidate: true,shouldDirty: true});
        }
    },[])

    const audienceOptions = [
        {
            value: 'customer',
            title: 'Customers',
            description: 'Send notifications to your customer base',
            icon: <People sx={{ fontSize: 40, color: 'primary.main' }} />,
            details: 'Target your registered customers with personalized notifications'
        },
        {
            value: 'expert',
            title: 'Service Experts',
            description: 'Send notifications to expert professionals',
            icon: <Engineering sx={{ fontSize: 40, color: 'primary.main' }} />,
            details: 'Communicate with your service experts with personalized notifications'
        },
        {
            value: 'csvUpload',
            title: 'CSV Upload (Non-Registered)',
            description: 'Upload phone numbers via CSV for WhatsApp',
            icon: <UploadFile sx={{ fontSize: 40, color: 'primary.main' }} />,
            details: 'Send WhatsApp messages to non-registered users by uploading phone numbers'
        }
    ];

    

    return (
        <Box component={'form'} onSubmit={handleSubmit(completeStep)}>
            <Card>
                <CardContent sx={{ height:'max-content' }}>
                    <Box sx={{display: 'flex', alignItems: 'center',justifyContent:'space-between'}}>
                        <Typography  gutterBottom sx={{ mb: 1, fontWeight: 600 ,fontSize:'0.85rem'}}>
                            Select Your Target Audience
                        </Typography>
                        {/* Selected Audience Info */}
                        {notificationData.audienceType && (
                            <Box 
                                sx={{ 
                                    // mt: 4, 
                                    p: .5, 
                                    bgcolor: 'success.50', 
                                    borderRadius: 1, 
                                    border: '1px solid', 
                                    borderColor: '#32cd32' ,
                                    display:"flex",
                                    
                                }}
                            >
                                <Typography sx={{ fontWeight: 600, color: '#008000',mr:1,fontSize:'0.75rem' }}>
                                    ✓ Selected: {notificationData.audienceType === 'customer' ? 'Customers' : notificationData.audienceType === 'expert' ? 'Experts' : 'CSV Upload'}
                                </Typography>
                                <Typography sx={{ color: '#32cd32',fontSize:'0.65rem' }}>
                                    {notificationData.audienceType === 'csvUpload' 
                                        ? 'You can upload a CSV file with phone numbers in the next step.'
                                        : 'You can proceed to apply specific filters for your selected audience in the next step.'}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <FormControl component="fieldset" fullWidth>
                        <Controller
                            name="audienceType"
                            control={control}
                            // defaultValue={watch('parentServiceId') == 0 ? 'parent' : 'child'}
                            rules={{ required: 'Please select audience type' }}
                            render={({ field }) => (
                                // <RadioGroup {...field} row>
                                //     <FormControlLabel
                                //         value="parent"
                                //         control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }} />}
                                //         label="Parent Service"
                                //         sx={{
                                //             '& .MuiFormControlLabel-label': {
                                //                 fontSize: '0.75rem'
                                //             }
                                //         }}
                                //     />
                                //     <FormControlLabel
                                //         value="child"
                                //         control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }} />}
                                //         label="Child Service"
                                //         sx={{
                                //             '& .MuiFormControlLabel-label': {
                                //                 fontSize: '0.75rem'
                                //             }
                                //         }}
                                //     />
                                // </RadioGroup>
                                <RadioGroup
                                    // value={notificationData.audienceType}
                                    // onChange={handleAudienceChange}
                                    {...field}
                                    sx={{ mt: 2 }}
                                >
                                    <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
                                        {audienceOptions.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={{ display: 'none' }} />}
                                                label={
                                                    <Card
                                                        sx={{
                                                            // minWidth: 280,
                                                            cursor: 'pointer',
                                                            border: 2,
                                                            borderColor: (watch('audienceType')) === option.value 
                                                                ? 'primary.main' 
                                                                : 'grey.300',
                                                            bgcolor: (watch('audienceType')) === option.value 
                                                                ? 'primary.50' 
                                                                : 'background.paper',
                                                            transition: 'all 0.2s ease-in-out',
                                                            '&:hover': {
                                                                borderColor: 'primary.main',
                                                                transform: 'translateY(-2px)',
                                                                boxShadow: 2
                                                            }
                                                        }}
                                                    >
                                                        <CardContent sx={{ textAlign: 'center', p: 1 }}>
                                                            <Avatar
                                                                sx={{
                                                                    width: 60,
                                                                    height: 60,
                                                                    bgcolor: (watch('audienceType')) === option.value 
                                                                        ? 'primary.main' 
                                                                        : 'grey.100',
                                                                    mx: 'auto',
                                                                    // mb: 2
                                                                }}
                                                            >
                                                                {React.cloneElement(option.icon, {
                                                                    sx: { 
                                                                        fontSize: 30, 
                                                                        color: (watch('audienceType')) === option.value 
                                                                            ? 'white' 
                                                                            : 'primary.main'
                                                                    }
                                                                })}
                                                            </Avatar>
                                                            
                                                            <Typography 
                                                                variant="h6" 
                                                                gutterBottom
                                                                sx={{
                                                                    fontWeight: 600,
                                                                    fontSize: '.85rem',
                                                                    color: notificationData.audienceType === option.value 
                                                                        ? 'primary.main' 
                                                                        : 'text.primary'
                                                                }}
                                                            >
                                                                {option.title}
                                                            </Typography>
                                                            
                                                            <Typography 
                                                                color="text.secondary"
                                                                sx={{fontSize: '0.75rem'}}
                                                            >
                                                                {option.description}
                                                            </Typography>
                                                            
                                                            <Typography 
                                                                variant="caption" 
                                                                sx={{ 
                                                                    fontSize: '0.65rem',
                                                                    fontStyle: 'italic',
                                                                    color: 'text.secondary'
                                                                }}
                                                            >
                                                                {option.details}
                                                            </Typography>
                                                        </CardContent>
                                                    </Card>
                                                }
                                                sx={{ m: 0 }}
                                            />
                                        ))}
                                        
                                    </Box>
                                </RadioGroup>
                            )}
                        />
                    </FormControl>
                    <FormControl component="fieldset" fullWidth>                        
                        
                    </FormControl>
                </CardContent>
            </Card>
            {/* Navigation Buttons */}
            <NavigationButton isDirty={isDirty} disableBackButton={true}/>
        </Box>
    );
};

export default AudienceSelection;